import { ERRORS_MESSAGE } from "@lhd/constants";
import { Checkbox, Form, Input } from "antd";
import { FC } from "react";

type PropsType = {
  getFieldClassName?: (name: string) => string;
};

const EmployeeInfoChildSelectionSetting: FC<PropsType> = ({
  getFieldClassName,
}) => {
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default EmployeeInfoChildSelectionSetting;
